import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { PaymentMethod } from 'src/app/models/PaymentModels';
import { Subscription } from 'rxjs';
import { PaymentsService } from 'src/app/services/payments.service';
import { ToastrService } from 'ngx-toastr';
import { AssignPaymentMethodComponent } from '../assign-payment-method/assign-payment-method.component';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-edit-payment-method',
  templateUrl: './edit-payment-method.component.html',
  styleUrls: ['./edit-payment-method.component.less']
})
export class EditPaymentMethodComponent implements OnInit {

  @ViewChild('editPmtForm',{}) ngForm: NgForm;
  @ViewChild('assignPmtForm', {}) assignPmtForm:AssignPaymentMethodComponent;
  @Input() _paymentMethod : PaymentMethod;
  @Input() clientId : number;

  private paymentMethod : PaymentMethod = new PaymentMethod();

  public originalValues : any[] = [];
  public changes : any[] = [];
  formChangesSubscription: Subscription;
  updates : ObjectUpdatePayload[] = [];

  constructor(public modalService: NgbModal, private paymentsService: PaymentsService, private toast: ToastrService, private auth: AuthService) { }

  ngOnInit() {
    console.log(this._paymentMethod);
    this.paymentMethod = Object.assign(this.paymentMethod, this._paymentMethod);
  }

  public get model() : PaymentMethod {
    return this.paymentMethod;
  }

  public save() : void {
    if(this.ngForm.valid) {    
      console.log(this.updates);
      this.paymentsService.EditPaymentMethod(this.paymentMethod).subscribe(r => {
        this.toast.success('Payment method edited!', '');
        Object.assign(this._paymentMethod, this.paymentMethod);
        let assigned = this.assignPmtForm.save();
        if(!assigned)
          this.modalService.dismissAll();
      },
      err => this.toast.error('There was an error editing your payment method!', '', { closeButton: true, disableTimeOut: true }));
    }
  }

  public cancel() : void {

    this.modalService.dismissAll();
  }

  public assign() : void {
    this.assignPmtForm.save();
  }

  public delete() : void {
    this.paymentsService.DeletePaymentMethod(this._paymentMethod);
  }
}
